import { useContext, type FC, useEffect, useState } from "react";
import { HeaderWrapper, LoginLink, StyledHeader } from "./header.styles";
import { Nav } from "./nav";
import { ReactComponent as UserIcon } from "@src/core/icons/user.svg";
import { AuthIcon } from "./auth-icon";
import { Store } from "@src/core/store";
import { Container } from "@src/core/styles";
import { getLocalStorage } from "@src/core/utils";
import { setNameValue } from "@src/core/store/authorize";
import { APP_ROUTES } from "@src/core/constants";

export const Header: FC = () => {
  const {
    state: {
      authorizeStore: { name },
    },
    dispatch,
  } = useContext(Store);

  useEffect(() => {
    const user = window.user;
    if (user.user) {
      dispatch(setNameValue(user.user.login as string));
    }
  }, [dispatch]);

  return (
    <HeaderWrapper>
      <Container>
        <StyledHeader>
          <Nav isAuth={name.length !== 0}/>
          {name.length === 0 ? (
            <LoginLink to={`${APP_ROUTES.LOGIN}`}>
              <UserIcon />
              <div>Войти</div>
            </LoginLink>
          ) : (
            <AuthIcon name={name} />
          )}
        </StyledHeader>
      </Container>
    </HeaderWrapper>
  );
};
